module.exports = "https://cdn-shared.mathletics.com/mathsaz/99/assets/images/d7991a738bee2093945808248299c046.svg";